// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__beneficiarySection___FoEmc,
.styles__grantorSection___EmRl9 {
  margin-bottom: 30px;
}

.styles__buttons___GgebR {
}

.styles__button___PM6kZ {
}

.styles__buttonLocal___nu30g {
}

.styles__buttonSecondary___WiQU9 {
}

.styles__errors___Vff1k {
}

.styles__formItemHalf___Aye19 {
}

.styles__formItemHelp___AYtjP {
  margin: 0 0 10px;
}

.styles__grantor___G_Nqu {
  margin-bottom: 20px;
}

.styles__input___f9f4M {
}

.styles__label___vb7LT {
}

.styles__renderButtons___c36XY {
  margin-bottom: 20px;
}

.styles__renderButtons___c36XY .styles__buttonSecondary___WiQU9,
  .styles__renderButtons___c36XY .styles__buttonLocal___nu30g {
    margin-right: 20px;
  }

.styles__renderButtons___c36XY .styles__buttonSecondary___WiQU9:last-child, .styles__renderButtons___c36XY .styles__buttonLocal___nu30g:last-child {
      margin-left: 0;
    }

.styles__section___YA_Nd {
  margin-bottom: 20px;
  position: relative;
}

.styles__section___YA_Nd h2 {
    margin-bottom: 20px;
  }

.styles__sectionTitle___sq025 {
  margin-bottom: 10px;
}

.styles__select___tJGLY {
}

.styles__errorSection___MlA6e .styles__label___vb7LT {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-bottom: 10px;
}

.styles__dynamicInput___VgIGg {

  padding-bottom: 10px;
}

.styles__dynamicInput___VgIGg input,
  .styles__dynamicInput___VgIGg .Select-control {
    width: calc(99.9% * 1/2 - (30px - 30px * 1/2));
  }

.styles__dynamicInput___VgIGg input:nth-child(1n),
  .styles__dynamicInput___VgIGg .Select-control:nth-child(1n) {
    float: left;
    margin-right: 30px;
    clear: none;
  }

.styles__dynamicInput___VgIGg input:last-child,
  .styles__dynamicInput___VgIGg .Select-control:last-child {
    margin-right: 0;
  }

.styles__dynamicInput___VgIGg input:nth-child(2n),
  .styles__dynamicInput___VgIGg .Select-control:nth-child(2n) {
    margin-right: 0;
    float: right;
  }

.styles__dynamicInput___VgIGg input:nth-child(2n + 1),
  .styles__dynamicInput___VgIGg .Select-control:nth-child(2n + 1) {
    clear: both;
  }

@media (max-width: 960px) {

.styles__dynamicInput___VgIGg input,
  .styles__dynamicInput___VgIGg .Select-control {
      width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  }

.styles__dynamicInput___VgIGg input:nth-child(1n),
  .styles__dynamicInput___VgIGg .Select-control:nth-child(1n) {
      float: left;
      margin-right: 30px;
      clear: none;
  }

.styles__dynamicInput___VgIGg input:last-child,
  .styles__dynamicInput___VgIGg .Select-control:last-child {
      margin-right: 0;
  }

.styles__dynamicInput___VgIGg input:nth-child(1n),
  .styles__dynamicInput___VgIGg .Select-control:nth-child(1n) {
      margin-right: 0;
      float: right;
  }

.styles__dynamicInput___VgIGg input:nth-child(1n + 1),
  .styles__dynamicInput___VgIGg .Select-control:nth-child(1n + 1) {
      clear: both;
  }
    }
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Account/components/Create/styles.css"],"names":[],"mappings":"AAIA;;EAEE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,mBAAmB;AAUrB;;AARE;;IAEE,kBAAkB;EAKpB;;AAHE;MACE,cAAc;IAChB;;AAIJ;EAEE,mBAAmB;EACnB,kBAAkB;AAIpB;;AAHE;IACE,mBAAmB;EACrB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;AAEA;;AAEA;EACE,mDAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAYE,oBAAoB;AACtB;;AAVE;;IAEE,8CAAgB;EAKlB;;AAPA;;IAEE,WAAgB;IAAhB,kBAAgB;IAAhB,WAAgB;EAKlB;;AAPA;;IAEE,eAAgB;EAKlB;;AAPA;;IAEE,eAAgB;IAAhB,YAAgB;EAKlB;;AAPA;;IAEE,WAAgB;EAKlB;;AAHE;;AAJF;;MAKI,8CAAkB;EAEtB;;AAPA;;MAKI,WAAkB;MAAlB,kBAAkB;MAAlB,WAAkB;EAEtB;;AAPA;;MAKI,eAAkB;EAEtB;;AAPA;;MAKI,eAAkB;MAAlB,YAAkB;EAEtB;;AAPA;;MAKI,WAAkB;EAEtB;IADE","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtBlueDark, gtRed from colors;\n\n.beneficiarySection,\n.grantorSection {\n  margin-bottom: 30px;\n}\n\n.buttons {\n  composes: buttons from helpers;\n}\n\n.button {\n  composes: button from helpers;\n}\n\n.buttonLocal {\n  composes: buttonLocal from helpers;\n}\n\n.buttonSecondary {\n  composes: buttonSecondary from helpers;\n}\n\n.errors {\n  composes: errors from helpers;\n}\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n}\n\n.formItemHelp {\n  margin: 0 0 10px;\n}\n\n.grantor {\n  margin-bottom: 20px;\n}\n\n.input {\n  composes: input from helpers;\n}\n\n.label {\n  composes: label from helpers;\n}\n\n.renderButtons {\n  margin-bottom: 20px;\n\n  .buttonSecondary,\n  .buttonLocal {\n    margin-right: 20px;\n\n    &:last-child {\n      margin-left: 0;\n    }\n  }\n}\n\n.section {\n  composes: boxWrap from helpers;\n  margin-bottom: 20px;\n  position: relative;\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.sectionTitle {\n  margin-bottom: 10px;\n}\n\n.select {\n  composes: select from helpers;\n}\n\n.errorSection .label {\n  color: gtRed;\n  margin-bottom: 10px;\n}\n\n.dynamicInput {\n  composes: formItem from helpers;\n\n  input,\n  :global(.Select-control) {\n    lost-column: 1/2;\n\n    @media (max-width: 960px) {\n      lost-column: 1 / 1;\n    }\n  }\n\n  padding-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"beneficiarySection": `styles__beneficiarySection___FoEmc`,
	"grantorSection": `styles__grantorSection___EmRl9`,
	"buttons": `styles__buttons___GgebR ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttons"]}`,
	"button": `styles__button___PM6kZ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`,
	"buttonLocal": `styles__buttonLocal___nu30g ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonLocal"]}`,
	"buttonSecondary": `styles__buttonSecondary___WiQU9 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["buttonSecondary"]}`,
	"errors": `styles__errors___Vff1k ${___CSS_LOADER_ICSS_IMPORT_1___.locals["errors"]}`,
	"formItemHalf": `styles__formItemHalf___Aye19 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItemHalf"]}`,
	"formItemHelp": `styles__formItemHelp___AYtjP`,
	"grantor": `styles__grantor___G_Nqu`,
	"input": `styles__input___f9f4M ${___CSS_LOADER_ICSS_IMPORT_1___.locals["input"]}`,
	"label": `styles__label___vb7LT ${___CSS_LOADER_ICSS_IMPORT_1___.locals["label"]}`,
	"renderButtons": `styles__renderButtons___c36XY`,
	"section": `styles__section___YA_Nd ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]}`,
	"sectionTitle": `styles__sectionTitle___sq025`,
	"select": `styles__select___tJGLY ${___CSS_LOADER_ICSS_IMPORT_1___.locals["select"]}`,
	"errorSection": `styles__errorSection___MlA6e`,
	"dynamicInput": `styles__dynamicInput___VgIGg ${___CSS_LOADER_ICSS_IMPORT_1___.locals["formItem"]}`
};
export default ___CSS_LOADER_EXPORT___;
